import { Provider } from "react-redux";
import store from "@/redux";
import React from "react";
import i18n from "@/common/languages/i18next";
import { I18nextProvider } from "react-i18next";
import { IMessageFromDialog } from "@/services";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import OrderInitialContainer from "./order-initial/OrderInitialContainer";

export interface  IOrderDialogViewProps {
  messageToParent?: (messageObject: IMessageFromDialog) => void;
}

export function OrderDialogView(
  props: IOrderDialogViewProps
) {
  //load the store and the resource finder component

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <I18nextProvider i18n={i18n}>
          <Provider store={store}>
            <OrderInitialContainer {...props} />
          </Provider>
        </I18nextProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
}
